import React from "react"
import { CheckIcon } from "lucide-react"

export function StatusProgress({ steps, currentStep }) {
  return (
    <div className="space-y-3">
      {steps.map((step, index) => {
        const isCompleted = index < currentStep
        const isActive = index === currentStep

        return (
          <div key={index} className="flex items-center gap-3">
            <div
              className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border text-sm font-medium
                ${
                  isCompleted
                    ? "border-purple-600 bg-purple-600 text-white"
                    : isActive
                      ? "border-purple-600 text-purple-600 animate-pulse"
                      : "border-gray-200 dark:border-gray-700 text-gray-400"
                }`}
            >
              {isCompleted ? <CheckIcon className="h-4 w-4" /> : index + 1}
            </div>
            <span
              className={`text-sm ${
                isCompleted ? "text-gray-700 dark:text-gray-300 font-medium" : isActive ? "text-purple-600 dark:text-purple-400 font-medium" : "text-gray-400 dark:text-gray-500"
              }`}
            >
              {step}
            </span>
          </div>
        )
      })}
    </div>
  )
} 